if($('.type-detail').length){
    var shouldExecuteFunction = true;
    for (var i = 0; i < classToHide.length; i++) {
        if ($('.p-detail .flags').find(classToHide[i]).length > 0) {
            shouldExecuteFunction = false;
            break;
        }
    }
    if (shouldExecuteFunction) {
        $('.p-image .flag-discount').hide()
        $('.p-final-price-wrapper .price-standard').hide()
    }
}